import React from "react";
import { isEmpty } from "../../Util";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import i18next from "i18next";

const Layout = (prop) => {
    const isWhiteLabel = useSelector((state) => state.Reducer.settings?.isWhiteLabel)
    const { t } = useTranslation();

    const getPrivacyNoticeUrl = () => {
        switch(i18next.language){
            case('fr'):
                return process.env.REACT_APP_PRIVACY_NOTICE_FR
            case('it'):
                return process.env.REACT_APP_PRIVACY_NOTICE_IT
            default : 
                return process.env.REACT_APP_PRIVACY_NOTICE
        }
    }

    const currentPrivacyNoticeUrl = getPrivacyNoticeUrl();

    return (
        <div className="container">
            { 
                (!prop.hideLogo && !isEmpty(isWhiteLabel) && !isWhiteLabel) &&
                <header className="d-flex az-header-container justify-content-center">
                    <img rel="preload" src={process.env.PUBLIC_URL + 'images/az-pay-logo.svg'}
                        alt="Allianz trade"
                        className='az-pay-logo'/>
                </header>
            }
            
            <main role="main" className="az-main-content">
                {prop.children}
            </main>
            
            {
                (!prop.hideLogo && !isEmpty(isWhiteLabel) && !isWhiteLabel) &&
                <footer className="d-flex az-footer-container justify-content-center">
                    <span>
                        <a className="az-footer-privacy" href={currentPrivacyNoticeUrl}>
                        Privacy notice   
                        </a>  • ©Allianz Trade 2025
                    </span>
                </footer>
            }
           
        </div>
    )
}

export default Layout;